import styled from 'styled-components'
import { Spin as SpinAnt } from 'antd'

export const Spin = styled(SpinAnt)`
  display: flex;
  justify-content: center;
  text-align: center;
`
